import { render, staticRenderFns } from "./AppSkeleton.vue?vue&type=template&id=5e4e0256&"
import script from "./AppSkeleton.vue?vue&type=script&lang=js&"
export * from "./AppSkeleton.vue?vue&type=script&lang=js&"
import style0 from "./AppSkeleton.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports